module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/sections--ceo-introduction.5b327c5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/sections--ceo-introduction.pdf
// module id = 3kDD
// module chunks = 10